import React from 'react';
import { Box } from '~ui-kit/components/box/box';
import { Typography } from '~ui-kit/components/typography/typography';
import { theme } from '~ui-kit/theme';

interface QuestionSubtitleProps {
  text: string;
}

export function QuestionSubtitle({ text }: QuestionSubtitleProps) {
  return (
    <Box data-id="question-subtitle" align="center" justify="center" flexDirection="column" width={['100%']}>
      <Typography
        component="h3"
        $fontFamily="Poppins"
        $color={theme.colors.secondaryDark}
        $fontSize={['18px', '18px', '20px']}
        $mb={2}
        $mx={2}
      >
        {text}
      </Typography>
    </Box>
  );
}
